import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { IAMAccountEntityRaw } from "@youm-front/iam-account/domain";
import { IAMAccountsActions } from "../actions";

export const IAM_ACCOUNTS_FEATURE_KEY = "iam-accounts";

export interface IAMAccountsState extends EntityState<IAMAccountEntityRaw> {
  isLoading: boolean;
}

export const iamAccountsAdapter: EntityAdapter<IAMAccountEntityRaw> =
  createEntityAdapter<IAMAccountEntityRaw>({
    selectId: (_) => _.identityAccountId,
    sortComparer: (lhs, rhs) => lhs.identity.localeCompare(rhs.identity)
  });

const initialState: IAMAccountsState = iamAccountsAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialState,
  on(
    IAMAccountsActions.iamAccountsList,
    IAMAccountsActions.iamAccountCreate,
    IAMAccountsActions.iamAccountCredentialsUpdate,
    IAMAccountsActions.iamAccountDelete,
    IAMAccountsActions.iamAccountUpdate,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(IAMAccountsActions.iamAccountsListSuccess, (state, { accounts }) =>
    iamAccountsAdapter.setAll(
      accounts.map((_) => _.toJSON()),
      {
        ...state,
        isLoading: false
      }
    )
  ),
  on(
    IAMAccountsActions.iamAccountCreateSuccess,
    IAMAccountsActions.iamAccountCredentialsUpdateSuccess,
    IAMAccountsActions.iamAccountUpdateSuccess,
    (state, { account }) =>
      iamAccountsAdapter.setOne(account.toJSON(), {
        ...state,
        isLoading: false
      })
  ),
  on(
    IAMAccountsActions.iamAccountDeleteSuccess,
    (state, { iamAccountDeleteCmd }) =>
      iamAccountsAdapter.removeOne(iamAccountDeleteCmd.value.accountId, {
        ...state,
        isLoading: false
      })
  ),
  on(
    IAMAccountsActions.iamAccountsListFailure,
    IAMAccountsActions.iamAccountCreateFailure,
    IAMAccountsActions.iamAccountCredentialsUpdateFailure,
    IAMAccountsActions.iamAccountDeleteFailure,
    IAMAccountsActions.iamAccountUpdateFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    IAMAccountsActions.iamAccountCredentialsDownloaded,
    (state, { iamAccountCredentialsDownloadedCmd }) =>
      iamAccountsAdapter.updateOne(
        {
          id: iamAccountCredentialsDownloadedCmd.value.account.value
            .identityAccountId,
          changes: {
            password: undefined
          }
        },
        state
      )
  )
);

export function iamAccountsReducer(
  state: IAMAccountsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
